
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jewellery/[slug]",
      function () {
        return require("private-next-pages/jewellery/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jewellery/[slug]"])
      });
    }
  